import { Check } from 'lucide-react';

import { useEntityColorPalette } from './EntityColorPaletteProvider';
import { getOnEntityColor } from './entityColorPalette';

export type EntityColorPickerProps = {
  value: string;
  onChange: (color: string) => void;
  disabled?: boolean;
  label?: string;
};

export function EntityColorPicker({
  value,
  onChange,
  disabled = false,
  label = 'Цвет',
}: EntityColorPickerProps) {
  const palette = useEntityColorPalette();
  return (
    <fieldset className="entity-color-picker" disabled={disabled}>
      <legend>{label}</legend>
      <div role="radiogroup" aria-label={label}>
        {palette.colors.map(color => {
          const selected = value === color.hex;
          return (
            <button
              type="button"
              key={color.id}
              role="radio"
              aria-label={`Выбрать цвет ${color.id} ${color.name} ${color.hex}`}
              aria-checked={selected}
              disabled={disabled}
              onClick={() => onChange(color.hex)}
            >
              <span style={{ backgroundColor: color.hex, color: getOnEntityColor(color.hex) }}>
                {selected ? <Check size={17} strokeWidth={3} /> : null}
              </span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
